<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M27.026 14.307L6.897 4.267a1.932 1.932 0 00-2.174.145 1.935 1.935 0 00-.61 2.159l3.358 8.134a.494.494 0 00.453.325h8.626a.975.975 0 01.672.255c.184.168.298.4.32.65a.974.974 0 01-.259.721.956.956 0 01-.698.304h-8.66a.486.486 0 00-.454.325L4.114 25.42a1.959 1.959 0 00.244 1.759 1.929 1.929 0 001.56.822c.325-.002.645-.084.931-.241l20.177-10.076a1.93 1.93 0 00.713-.711 1.956 1.956 0 00-.713-2.665z"/></svg>
</template>

<script>
export default {
  name: 'symbolsPaperPlaneRightFilled'
}
</script>
